import { MockDatabase, MockRecord, MockTable } from "../MockDatabase";

export class MockSchemaData extends MockTable {
    constructor(db: MockDatabase) {
        super(db);
        this.name = 'schema_data';
        this.fields = {
            id: this.PrimaryKey({
                fieldName: 'id'
            }),
            schema_data_id: this.Field({
                type: 'GUID',
                fieldName: 'schema_data_id',
                nullable: false,
                index: true,
                default: {
                    method: 'UUID'
                }
            }),
            schema_type_id: this.ForeignKey({
                fieldName: 'schema_type_id',
                nullable: false,
                index: true,
                foreignTableName: 'schema_type',
                foreignTableFieldName: 'id',
            }),
            schema_data_version: this.Field({
                type: 'number',
                fieldName: 'schema_data_version',
                nullable: true,
            }),
            data: this.Field({
                type: 'string',
                fieldName: 'data',
                nullable: true,
                default: {
                    value: '{}'
                }
            }),
            parent_id: this.ForeignKey({ // Intended to be an open ended foreign key to any other table, but it is not leveraged by SP
                fieldName: 'parent_id',
                nullable: true,
                foreignTableName: 'attributions',
                foreignTableFieldName: 'id',
            }),
            parent_type: this.Field({ // Intended to be an enum representation for the foreign key above. The value of this field is meant to identify which table the foreign key references. Again, not leveraged by SP
                type: 'number',
                fieldName: 'parent_type',
                nullable: true,
                default: {
                    value: 1
                }
            }),
            latest: this.Field({ // Intended to be an enum representation for the foreign key above. The value of this field is meant to identify which table the foreign key references. Again, not leveraged by SP
                type: 'number',
                fieldName: 'latest',
                nullable: true,
                default: {
                    value: 1
                }
            }),
            created_date: this.Field({
                type: 'datetime',
                fieldName: 'created_date',
                nullable: false,
                default: {
                    method: 'NOW'
                }
            }),
            updated_date: this.Field({
                type: 'datetime',
                fieldName: 'updated_date',
                nullable: false,
                default: {
                    method: 'NOW',
                    onUpdate: true
                }
            }),
        }
    }

    protected afterCreate: (db: MockDatabase, table: MockTable, records: MockRecord[]) => void = (db: MockDatabase, table: MockTable, records: MockRecord[]) => {
        // Handle latest logic
        const prevRec = table.query([
            {fieldName: 'schema_data_id', value: records[0].values['schema_data_id']}
        ]);
        prevRec.sort((a,b) => a.values['created_date'].localeCompare(b.values['created_date'])).forEach((prev, idx) => prev.update(db, table, {
            latest: 0,
            schema_data_version: idx+1
        }));
        records[0].values['latest'] = 1;
        records[0].values['schema_data_version'] = prevRec.length;
    }

    protected afterDelete: (db: MockDatabase, table: MockTable, records: MockRecord[]) => void = (db: MockDatabase, table: MockTable, records: MockRecord[]) => {
        // Handle "latest" logic
        const schemaDataIds = records.reduce((acc, cur) => {
            const dataId = cur.values['schema_data_id'];
            if (acc.indexOf(dataId) === -1) {
                acc.push(dataId);
            }
            return acc;
        }, [] as string[]);
        const updateRecs = schemaDataIds.reduce((acc, cur) => {
            acc.push(...table.query([
                {fieldName: 'schema_data_id', value: records[0].values['schema_data_id']}
            ]));
            return acc;
        }, [] as MockRecord[]);
        table.updateRecords(updateRecs, {
            latest: 0
        });
    }
}